import React from 'react';
import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';





const  UserDatatable = (props) => {

    const [t] = useTranslation();      
    const tableName = t('user.label.users');     
  

    const columns = [       
             { name: "Id", data: "id", selector: "id", omit: true},
             { name: t('user.label.personalNumber'), data: "personalNumber", sortable: true, selector: "personalNumber"},    		
             { name: t('user.label.login'), data: "login", sortable: true, selector: "login"},    		
             { name: t('user.label.firstName'), data: "address.firstName",  sortable: true,  selector: "address.firstName"} ,            
             { name: t('user.label.lastName'), data: "address.lastName",  sortable: true,  selector: "address.lastName"} ,
             { name: t('user.label.mobilePhone'), data: "address.mobilePhone",  sortable: true,  selector: "address.mobilePhone"} ,
             { name: t('user.label.officeEmail'), data: "address.officeEmail",  sortable: true,  selector: "address.officeEmail"} ,
             { name: t('user.label.workPosition'), data: "workPosition.positionName",  sortable: true,  selector: "workPosition.positionName"} ,
             { name: t('user.label.department'), data: "department.name",  sortable: true,  selector: "department.name"} 
     ];        
 
 
         
     const columnsData = [       
         { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
         { name: t('user.label.personalNumber'), data: "personalNumber",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
         { name: t('user.label.login'), data: "login", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('user.label.firstName'), data: "address.firstName", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('user.label.lastName'), data: "address.lastName", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('user.label.mobilePhone'), data: "address.mobilePhone", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('user.label.officeEmail'), data: "address.officeEmail", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('user.label.workPosition'), data: "workPosition.positionName", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('user.label.department'), data: "department.name", orderable: true,  searchable: true, search: {value: '',regex: false}}             
     ];        
     
     const url = RestService.getBaseURL()+"user/getUsersDataTableList";  
     const urlExcel = RestService.getBaseURL()+"";          
    
   
 
  
     const handleCallback  = (id) => {
             props.parentCallback(id);                   
     };
   
    
    
         return (
           
             <DataTableX
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}
                 parentCallback={handleCallback}
                 modalShow={props.modalShow}
                 exportShow={false}
             />
           
         );
    
 
  
 };

export default UserDatatable;

